"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Namespace = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
exports.protobufPackage = "snapchat.cdp.cof";
/** Namespace for grouping COF entities. */
var Namespace;
(function (Namespace) {
    Namespace[Namespace["DEFAULT"] = 0] = "DEFAULT";
    Namespace[Namespace["CAMERA"] = 1] = "CAMERA";
    Namespace[Namespace["COF"] = 2] = "COF";
    Namespace[Namespace["MDP"] = 3] = "MDP";
    Namespace[Namespace["MONETIZATION"] = 4] = "MONETIZATION";
    Namespace[Namespace["LEGACY_AB"] = 5] = "LEGACY_AB";
    /** AB_STUDY_VERSION - The value of a AB config is study version. */
    Namespace[Namespace["AB_STUDY_VERSION"] = 6] = "AB_STUDY_VERSION";
    Namespace[Namespace["CAMERA_PLATFORM"] = 7] = "CAMERA_PLATFORM";
    Namespace[Namespace["PLATFORM_UI"] = 8] = "PLATFORM_UI";
    Namespace[Namespace["PLATFORM_CORE"] = 9] = "PLATFORM_CORE";
    Namespace[Namespace["MONETIZATION_UI"] = 10] = "MONETIZATION_UI";
    Namespace[Namespace["MONETIZATION_RANKING"] = 11] = "MONETIZATION_RANKING";
    Namespace[Namespace["USERS_AND_FRIENDS_UI"] = 12] = "USERS_AND_FRIENDS_UI";
    Namespace[Namespace["USERS_AND_FRIENDS_CORE"] = 13] = "USERS_AND_FRIENDS_CORE";
    Namespace[Namespace["USERS_AND_FRIENDS_RANKING"] = 14] = "USERS_AND_FRIENDS_RANKING";
    Namespace[Namespace["MESSAGING_UI"] = 15] = "MESSAGING_UI";
    Namespace[Namespace["MESSAGING_CORE"] = 16] = "MESSAGING_CORE";
    /** @deprecated */
    Namespace[Namespace["STORIES_UI"] = 17] = "STORIES_UI";
    Namespace[Namespace["STORIES_CORE"] = 18] = "STORIES_CORE";
    Namespace[Namespace["STORIES_RANKING"] = 19] = "STORIES_RANKING";
    Namespace[Namespace["DISCOVER_UI"] = 20] = "DISCOVER_UI";
    Namespace[Namespace["DISCOVER_CORE"] = 21] = "DISCOVER_CORE";
    Namespace[Namespace["DISCOVER_RANKING"] = 22] = "DISCOVER_RANKING";
    Namespace[Namespace["PREMIUM_CONTENT_UI"] = 23] = "PREMIUM_CONTENT_UI";
    Namespace[Namespace["PREMIUM_CONTENT_CORE"] = 24] = "PREMIUM_CONTENT_CORE";
    Namespace[Namespace["PREMIUM_CONTENT_RANKING"] = 25] = "PREMIUM_CONTENT_RANKING";
    Namespace[Namespace["COMMUNITY_UI"] = 26] = "COMMUNITY_UI";
    Namespace[Namespace["COMMUNITY_CORE"] = 27] = "COMMUNITY_CORE";
    Namespace[Namespace["COMMUNITY_RANKING"] = 28] = "COMMUNITY_RANKING";
    Namespace[Namespace["CAMERA_UI"] = 29] = "CAMERA_UI";
    Namespace[Namespace["CREATIVE_TOOLS_UI"] = 30] = "CREATIVE_TOOLS_UI";
    Namespace[Namespace["CREATIVE_TOOLS_CORE"] = 31] = "CREATIVE_TOOLS_CORE";
    Namespace[Namespace["CAMERA_PLATFORM_UI"] = 32] = "CAMERA_PLATFORM_UI";
    Namespace[Namespace["CAMERA_PLATFORM_RANKING"] = 33] = "CAMERA_PLATFORM_RANKING";
    Namespace[Namespace["PERCEPTION_UI"] = 34] = "PERCEPTION_UI";
    Namespace[Namespace["PERCEPTION_CORE"] = 35] = "PERCEPTION_CORE";
    Namespace[Namespace["PERCEPTION_RANKING"] = 36] = "PERCEPTION_RANKING";
    Namespace[Namespace["MEDIA_UI"] = 37] = "MEDIA_UI";
    Namespace[Namespace["MEMORIES_UI"] = 38] = "MEMORIES_UI";
    Namespace[Namespace["MEMORIES_CORE"] = 39] = "MEMORIES_CORE";
    Namespace[Namespace["MAP_UI"] = 40] = "MAP_UI";
    Namespace[Namespace["MAP_CORE"] = 41] = "MAP_CORE";
    Namespace[Namespace["SEARCH_UI"] = 42] = "SEARCH_UI";
    Namespace[Namespace["SEARCH_CORE"] = 43] = "SEARCH_CORE";
    Namespace[Namespace["SEARCH_RANKING"] = 44] = "SEARCH_RANKING";
    Namespace[Namespace["COGNAC_UI"] = 45] = "COGNAC_UI";
    Namespace[Namespace["COGNAC_CORE"] = 46] = "COGNAC_CORE";
    Namespace[Namespace["BITMOJI_UI"] = 47] = "BITMOJI_UI";
    Namespace[Namespace["BITMOJI_CORE"] = 48] = "BITMOJI_CORE";
    Namespace[Namespace["SPECTACLES_UI"] = 49] = "SPECTACLES_UI";
    Namespace[Namespace["SPECTACLES_CORE"] = 50] = "SPECTACLES_CORE";
    Namespace[Namespace["SNAP_KIT_UI"] = 51] = "SNAP_KIT_UI";
    Namespace[Namespace["SNAP_KIT_CORE"] = 52] = "SNAP_KIT_CORE";
    Namespace[Namespace["SNAP_PRO_UI"] = 53] = "SNAP_PRO_UI";
    Namespace[Namespace["SNAP_PRO_CORE"] = 54] = "SNAP_PRO_CORE";
    Namespace[Namespace["NGS_UI"] = 55] = "NGS_UI";
    Namespace[Namespace["CAMEOS_UI"] = 56] = "CAMEOS_UI";
    Namespace[Namespace["CAMEOS_CORE"] = 57] = "CAMEOS_CORE";
    Namespace[Namespace["CAMEOS_RANKING"] = 58] = "CAMEOS_RANKING";
    Namespace[Namespace["BLIZZARD_CLIENT"] = 59] = "BLIZZARD_CLIENT";
    Namespace[Namespace["BLIZZARD_BACKEND"] = 60] = "BLIZZARD_BACKEND";
    Namespace[Namespace["AB_SEGMENT"] = 61] = "AB_SEGMENT";
    Namespace[Namespace["CONFIG_ROLLOUT"] = 62] = "CONFIG_ROLLOUT";
    Namespace[Namespace["COMMERCE_BACKEND"] = 63] = "COMMERCE_BACKEND";
    Namespace[Namespace["LENS_CORE"] = 64] = "LENS_CORE";
    Namespace[Namespace["CAMERA_KIT_CORE"] = 65] = "CAMERA_KIT_CORE";
    Namespace[Namespace["MDP_CONTENT_MANAGER"] = 66] = "MDP_CONTENT_MANAGER";
    Namespace[Namespace["REQUEST_DOMAIN_ROUTING"] = 67] = "REQUEST_DOMAIN_ROUTING";
    Namespace[Namespace["CDN_ROUTING"] = 68] = "CDN_ROUTING";
    Namespace[Namespace["GRAPHENE_SAMPLING"] = 69] = "GRAPHENE_SAMPLING";
    Namespace[Namespace["WEB_STORY_CORE"] = 70] = "WEB_STORY_CORE";
    Namespace[Namespace["WEB_STORY_UI"] = 71] = "WEB_STORY_UI";
    Namespace[Namespace["CLIENT_SWITCHBOARD"] = 72] = "CLIENT_SWITCHBOARD";
    /** MCS - Messaging core service, aka Arroyo.  See go/mcs-quick-exps */
    Namespace[Namespace["MCS"] = 73] = "MCS";
    Namespace[Namespace["SHARING_UI"] = 74] = "SHARING_UI";
    Namespace[Namespace["SHARING_CORE"] = 75] = "SHARING_CORE";
    Namespace[Namespace["SHARING_RANKING"] = 76] = "SHARING_RANKING";
    Namespace[Namespace["MDP_PLAYBACK"] = 77] = "MDP_PLAYBACK";
    Namespace[Namespace["CAMERA_BUSINESS"] = 78] = "CAMERA_BUSINESS";
    Namespace[Namespace["ADDLIVE"] = 79] = "ADDLIVE";
    /** AD_KIT_CORE - Ad Kit Core */
    Namespace[Namespace["AD_KIT_CORE"] = 80] = "AD_KIT_CORE";
    Namespace[Namespace["ADDLIVE_UI"] = 81] = "ADDLIVE_UI";
    Namespace[Namespace["ADDLIVE_CORE"] = 82] = "ADDLIVE_CORE";
    Namespace[Namespace["ADDLIVE_RANKING"] = 83] = "ADDLIVE_RANKING";
    Namespace[Namespace["STORY_STUDIO_LITE_UI"] = 84] = "STORY_STUDIO_LITE_UI";
    Namespace[Namespace["STORY_STUDIO_LITE_CORE"] = 85] = "STORY_STUDIO_LITE_CORE";
    Namespace[Namespace["COMMERCE_UI"] = 86] = "COMMERCE_UI";
    Namespace[Namespace["COMMERCE_CORE"] = 87] = "COMMERCE_CORE";
    Namespace[Namespace["COMMERCE_RANKING"] = 88] = "COMMERCE_RANKING";
    Namespace[Namespace["STORIES_UX"] = 89] = "STORIES_UX";
    /** CONTEXT_UI - Context / Interactions */
    Namespace[Namespace["CONTEXT_UI"] = 90] = "CONTEXT_UI";
    Namespace[Namespace["CONTEXT_CORE"] = 91] = "CONTEXT_CORE";
    Namespace[Namespace["LENS_TARGETING"] = 92] = "LENS_TARGETING";
    Namespace[Namespace["SPOTLIGHT_RANKING"] = 93] = "SPOTLIGHT_RANKING";
    Namespace[Namespace["SPOTLIGHT_CORE"] = 94] = "SPOTLIGHT_CORE";
    Namespace[Namespace["SPOTLIGHT_UI"] = 95] = "SPOTLIGHT_UI";
    Namespace[Namespace["ACTIVATION_CORE"] = 96] = "ACTIVATION_CORE";
    Namespace[Namespace["FRIENDING"] = 97] = "FRIENDING";
    /** SAFETY - Platform Integrity Engineering */
    Namespace[Namespace["SAFETY"] = 98] = "SAFETY";
    /** LOGIN - Login Processing */
    Namespace[Namespace["LOGIN"] = 99] = "LOGIN";
    Namespace[Namespace["MYLENSES_WEB_CORE"] = 100] = "MYLENSES_WEB_CORE";
    Namespace[Namespace["SECURITY"] = 101] = "SECURITY";
    Namespace[Namespace["AB_CONSOLE"] = 102] = "AB_CONSOLE";
    Namespace[Namespace["AD_MODERATION"] = 103] = "AD_MODERATION";
    Namespace[Namespace["CONTENT_LIFT_MEASUREMENT"] = 104] = "CONTENT_LIFT_MEASUREMENT";
    Namespace[Namespace["CONTEXT_BACKEND"] = 105] = "CONTEXT_BACKEND";
    Namespace[Namespace["GAMES_FEED_CORE"] = 106] = "GAMES_FEED_CORE";
    Namespace[Namespace["RECIPIENT_DEVICE_CAPABILITIES"] = 107] = "RECIPIENT_DEVICE_CAPABILITIES";
    /** ADS_GATEWAY_CORE - Ads Manager */
    Namespace[Namespace["ADS_GATEWAY_CORE"] = 108] = "ADS_GATEWAY_CORE";
    Namespace[Namespace["ADS_INTERFACES_UI"] = 109] = "ADS_INTERFACES_UI";
    Namespace[Namespace["ADS_MANAGER_UI"] = 110] = "ADS_MANAGER_UI";
    Namespace[Namespace["BUSINESS_MANAGER_UI"] = 111] = "BUSINESS_MANAGER_UI";
    Namespace[Namespace["PROFILE_MANAGER_UI"] = 112] = "PROFILE_MANAGER_UI";
    /** NOTIFICATION - Notification */
    Namespace[Namespace["NOTIFICATION"] = 113] = "NOTIFICATION";
    /** BILLBOARD - Billboard */
    Namespace[Namespace["BILLBOARD"] = 114] = "BILLBOARD";
    Namespace[Namespace["LENS_DELIVERY_CORE"] = 115] = "LENS_DELIVERY_CORE";
    /** TIER_0_LAUNCH - Namespace for major launches */
    Namespace[Namespace["TIER_0_LAUNCH"] = 116] = "TIER_0_LAUNCH";
    /** FRIENDING_REG - Namespace for friending suggestion in registration */
    Namespace[Namespace["FRIENDING_REG"] = 117] = "FRIENDING_REG";
    /** CAMERA_KIT_WEB_CORE - Namespace for @snapchat/camera-kit npm package */
    Namespace[Namespace["CAMERA_KIT_WEB_CORE"] = 118] = "CAMERA_KIT_WEB_CORE";
    Namespace[Namespace["MDP_OPERA_CORE"] = 119] = "MDP_OPERA_CORE";
    Namespace[Namespace["SHARED_WEB_UI"] = 120] = "SHARED_WEB_UI";
    /** CODELABS_SANDBOX - Sandbox namespace for A/B Codelabs. */
    Namespace[Namespace["CODELABS_SANDBOX"] = 121] = "CODELABS_SANDBOX";
    Namespace[Namespace["FRIENDING_QA_RANKING"] = 122] = "FRIENDING_QA_RANKING";
    Namespace[Namespace["FRIENDING_REG_RANKING"] = 123] = "FRIENDING_REG_RANKING";
    Namespace[Namespace["SEARCH_CSL"] = 124] = "SEARCH_CSL";
    Namespace[Namespace["WEB3"] = 125] = "WEB3";
    Namespace[Namespace["PLUS_CORE"] = 126] = "PLUS_CORE";
    Namespace[Namespace["WEB_STORYTELLER_UI"] = 127] = "WEB_STORYTELLER_UI";
    Namespace[Namespace["PLATFORM_SERVICES"] = 128] = "PLATFORM_SERVICES";
    Namespace[Namespace["WEB_ACCOUNTS"] = 129] = "WEB_ACCOUNTS";
    Namespace[Namespace["SHOPKIT_WEB"] = 130] = "SHOPKIT_WEB";
    Namespace[Namespace["SNAPGRAPH_MODSERVER"] = 131] = "SNAPGRAPH_MODSERVER";
    /** MUSIC - MUSIC is not a valid namespace name due to a conflict with another Enum. Use SOUNDS instead. */
    Namespace[Namespace["MUSIC"] = 132] = "MUSIC";
    Namespace[Namespace["SOUNDS"] = 133] = "SOUNDS";
    Namespace[Namespace["MACHAMP"] = 134] = "MACHAMP";
    Namespace[Namespace["PIE_AUTOBOT"] = 135] = "PIE_AUTOBOT";
    Namespace[Namespace["NOTIFICATION_RANKING"] = 136] = "NOTIFICATION_RANKING";
    Namespace[Namespace["PIE_CUP"] = 137] = "PIE_CUP";
    /** MESH_MANAGED_DEPLOYMENT - Used for mesh service deployment flow, e.g. client canary based deployment */
    Namespace[Namespace["MESH_MANAGED_DEPLOYMENT"] = 138] = "MESH_MANAGED_DEPLOYMENT";
    Namespace[Namespace["AD_CLIENT"] = 139] = "AD_CLIENT";
    Namespace[Namespace["PIE_AUTOBOT_REACTIVE"] = 140] = "PIE_AUTOBOT_REACTIVE";
    Namespace[Namespace["DYNAMIC_DEEPLINKING"] = 141] = "DYNAMIC_DEEPLINKING";
    Namespace[Namespace["SNAPCHAT_WEB_UI"] = 142] = "SNAPCHAT_WEB_UI";
    Namespace[Namespace["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Namespace = exports.Namespace || (exports.Namespace = {}));
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=namespace.js.map